import React, { useContext } from 'react';
import GeneralContext from '../../../context/GeneralContext/GeneralContext';
import { displayMessage } from '../../services/helper';

export default function PatientInfo() {
    const { mobile_mode, user } = useContext(GeneralContext);

    return (
        <div className='h-full w-full'>
            <div className='flex flex-1 justify-between p-2 bg-appian-blue gap-1'>
                <span className='self-center font-medium text-white flex-1 text-center text-base'>{displayMessage('INFO_PATIENT_TITLE')}</span>
            </div>
            <div className={`flex flex-wrap flex-1 bg-neutral-200 p-2 justify-between mb-6 w-full`}>
                <div className={`flex-row flex-1 min-w-[300px] mr-2 input-container`}>
                    <div className="text-lg">
                        <strong>{displayMessage('PATIENT')}:</strong><span className='ml-2'>{user?.full_name}</span>
                    </div>
                </div>
                <div className={`${mobile_mode ? 'flex-row' : 'flex-col'} flex-1 min-w-[300px] mr-2 input-container`}>
                    <div className="text-lg"><strong>{displayMessage('DENTIST')}:</strong><span className='ml-2'>{user?.dentist_name}</span></div>
                </div>
                <div className={`${mobile_mode ? 'flex-row' : 'flex-col'} flex-1 min-w-[300px] input-container`}>
                    <div className="text-lg">
                        <strong>{displayMessage('BALANCE_MANGOS')}:</strong><span className='ml-2'>{user?.mangos}</span>
                    </div>
                </div>
            </div>
        </div>
    );
}
